import React, { useEffect, useState } from 'react';
import Loader from '../../../components/general/loader';
import { WSContextProvider } from '../../../contexts/websockets';
import BattleRouter from '../../../components/pages/fight/battle';
import { IFightNft } from '../../../interfaces/FightNft';
import {
  BattleStage,
  BattleStageAfterConnect,
  BattleStages
} from '../../../interfaces/BattleStage';

interface Props {
  nft: IFightNft;
  bet: number;
  straightToFight: boolean;
}

const FightPageBattle = ({ nft, bet, straightToFight }: Props) => {
  const [stage, setStage] = useState<BattleStage>({
    marker: BattleStages.INIT
  });

  useEffect(() => {
    if (nft && bet != undefined) {
      switchToConnecting(
        nft,
        bet,
        straightToFight ? BattleStages.ACTION : BattleStages.WAITING
      );
    }
  }, []);

  const switchToConnecting = (
    nft: IFightNft,
    bet: number,
    nextStage: BattleStageAfterConnect
  ) => {
    setStage({ marker: BattleStages.CONNECTING, nft, bet, nextStage });
  };

  const switchToWaiting = (nft: IFightNft, bet: number) => {
    setStage({ marker: BattleStages.WAITING, nft, bet });
  };

  const switchToAction = (nft: IFightNft, bet: number) => {
    setStage({ marker: BattleStages.ACTION, nft, bet });
  };

  if (stage.marker === BattleStages.INIT) {
    return <Loader useAbsoluteWrapper />;
  }

  return (
    <WSContextProvider>
      <BattleRouter
        stage={stage}
        switchToWaiting={switchToWaiting}
        switchToAction={switchToAction}
      />
    </WSContextProvider>
  );
};

export default FightPageBattle;
